import { motion } from 'framer-motion';
import styled from 'styled-components';
import { TwoButton } from '../items/two.button';
import { Button } from '../items/Button';

interface ConfirmModalProps {
  handleConfirmClose: () => void;
  confirmText?: string;
  onClick?: () => void;
  onConfirm?: () => void;
}

export const AlertModal = ({
  handleConfirmClose,
  confirmText = 'confirm text',
  onClick,
  onConfirm,
}: ConfirmModalProps) => {
  const handleButtonClick = () => {
    if (onConfirm) {
      onConfirm(); // onConfirm이 존재하면 호출
    } else if (onClick) {
      onClick(); // onClick이 존재하면 호출
    }
    handleConfirmClose(); // 모달을 닫기
  };
  return (
    <ModalContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        type: 'fade',
      }}
    >
      <div className="overlay" onClick={handleConfirmClose}></div>
      <ModalInner
        className="wrapper"
        initial={{ y: '100%' }}
        animate={{ y: '0%' }}
        exit={{ y: '100%' }}
        transition={{
          type: 'spring',
          stiffness: 400,
          damping: 40,
        }}
      >
        <div className="modal-body">{confirmText}</div>
        <Button title="확인" onClick={handleButtonClick} />
      </ModalInner>
    </ModalContainer>
  );
};

// style
const ModalContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.6rem;
  cursor: 'pointer';
  width: 100%;
  height: 100%;
  .overlay {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
`;

const ModalInner = styled(motion.div)`
  max-width: 50rem;
  position: relative;
  z-index: 99;
  padding: 5rem 1.9rem 1.5rem;
  background-color: ${(props) => props.theme.textWhiteColor};
  width: 100%;
  min-height: 23.4rem;
  border-radius: 1.6rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .modal-body {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: 1.8rem;
    font-weight: 700;
    white-space: pre-wrap;
  }
`;
